import { useMutation, useQuery } from "@tanstack/react-query";

import { api } from "@services/index";
import {
  ApiErrorModel,
  NotificationModel,
  NotificationModelDto,
} from "@interfaces/index";

export const useNotificationGetAll = (enabled: boolean = true) => {
  const queryFn = async () => {
    const { data: dataDto } = await api.get<{
      notifications: NotificationModelDto[];
    }>("/notifications");

    const notifications = dataDto.notifications.map((notification) => ({
      id: notification.id,
      uniqueId: notification.data?.unique_id,
      isImportant: !!notification.data?.is_important,
      type: notification.type,
      title: notification.data?.title || "",
      message: notification.data?.message,
      actionLabel: notification.data?.action_label || "",
      readAt: notification.read_at,
      updatedAt: notification.updated_at,
    }));

    return notifications;
  };

  return useQuery<NotificationModel[], ApiErrorModel>({
    queryKey: ["notificationGetAll"],
    queryFn,
    refetchOnWindowFocus: true,
    enabled,
  });
};

export const useNotificationReadAll = (
  onSuccess?: () => void,
  onError?: (error: ApiErrorModel) => void,
) => {
  const mutationFn = async () => await api.post("/notifications");

  return useMutation({
    mutationKey: ["notificationReadAll"],
    mutationFn,
    onSuccess,
    onError: (error: ApiErrorModel) => {
      if (onError) {
        onError({ ...error });
      }
    },
  });
};

export const useNotificationReadOne = (
  onSuccess?: () => void,
  onError?: (error: ApiErrorModel) => void,
) => {
  const mutationFn = async (id: string) =>
    await api.post(`/notifications/${id}`);

  return useMutation({
    mutationKey: ["notificationReadOne"],
    mutationFn,
    onSuccess,
    onError: (error: ApiErrorModel) => {
      if (onError) {
        onError({ ...error });
      }
    },
  });
};
